import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { FormMutationTypes as MutationTypes } from './mutation-types';
import { FormActionTypes as ActionTypes } from './action-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.SET_CURRENT_TAB]({ commit }: AugmentedActionContext, payload: number): void;
  [ActionTypes.LOAD_CONFIG]({ commit }: AugmentedActionContext, payload: boolean): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.SET_CURRENT_TAB]({ commit }, payload: number) {
    commit(MutationTypes.SET_CURRENT_TAB, payload);
  },
  [ActionTypes.LOAD_CONFIG]({ commit }, payload: boolean) {
    commit(MutationTypes.LOAD_CONFIG, payload);
  },
};
